import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import consentReducer from '../features/consent/redux/ConsentSlice';
import standardKycReducer from '../features/standardkyc/redux/StandardKycSlice';
import digitalKycReducer from '../features/digitalkyc/redux/DigitalKycSlice';

export const store = configureStore({
  reducer: {
    consent: consentReducer,
    standardKyc: standardKycReducer,
    digitalKyc: digitalKycReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
